<div class="site-search">
	<button class="site-search__trigger button is-medium is-dark" @click="open" aria-label="Suche öffnen">
		<svg-icon name="search" />
	</button>

	<div v-if="isOpen" class="site-search__overlay" role="dialog" aria-modal="true" aria-label="Suche" @click="onOverlayClick" @keydown="onKeydown">
		<div class="site-search__panel">
			<div class="site-search__header">
				<div class="site-search__input-wrap">
					<input
						class="site-search__input input is-medium"
						:class="{ 'has-animated-placeholder': !query }"
						type="search"
						placeholder="Suchen nach …"
						v-model="query"
						aria-label="Suchbegriff"
						aria-autocomplete="list"
						aria-controls="site-search-results"
						:aria-activedescendant="activeDescendantId"
						@keydown="onInputKeydown"
					/>
					<div v-if="!query" class="site-search__placeholder" aria-hidden="true">
						<span class="site-search__placeholder-prefix">Suchen nach&nbsp;</span>
						<span class="site-search__placeholder-word" :class="{ 'is-faded': !placeholderVisible }">{{ currentPlaceholderWord }}</span>
					</div>
				</div>
				<button class="site-search__close button is-dark is-medium" @click="close" aria-label="Suche schliessen">
					<svg-icon name="close" />
				</button>
			</div>

			<div class="site-search__results" v-if="hasResults || showNoResults || isLoading">
				<div v-if="isLoading && page === 1" class="site-search__loading" aria-live="polite">
					<span>Suche…</span>
				</div>

				<div v-if="showNoResults" class="site-search__no-results" aria-live="polite">
					<p>Keine Ergebnisse für «{{ query }}»</p>
				</div>

				<ul v-if="hits.length > 0" id="site-search-results" class="site-search__list" role="listbox">
					<li
						v-for="(hit, index) in hits"
						:key="hit.url"
						:id="'site-search-hit-' + index"
						class="site-search-item"
						:class="{ 'is-active': index === activeIndex }"
						role="option"
						:aria-selected="index === activeIndex"
					>
						<a :href="hit.url" class="site-search-item__link" tabindex="-1">
							<img
								v-if="hit.imageUrl"
								:src="hit.imageUrl"
								:alt="hit.title"
								class="site-search-item__image"
								loading="lazy"
							/>
							<div class="site-search-item__title">
								<span class="title">{{ hit.title }}</span>
								<span v-if="hit.documentType" class="site-search-item__tag tag is-primary">{{ hit.documentType }}</span>
							</div>
							<div class="site-search-item__snippet" v-html="hit.snippet"></div>
						</a>
					</li>
				</ul>

				<div v-if="hasMore" class="site-search__load-more">
					<button class="button is-primary" :class="{'is-loading': isLoading}" @click="loadMore">Mehr anzeigen</button>
				</div>
			</div>
		</div>
	</div>
</div>
